// Formats an ISO (YYYY-MM-DD) or other parseable date string as "Month Date, Year" (e.g. "March 10, 2024").
// Returns the original value unchanged if it can't be parsed as a date.
export function formatLongDate(value: string | null | undefined): string {
  if (!value) return value ?? '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
}
// Formats a date string as "Mon D, YYYY" (e.g. "Jul 16, 2026"), matching the People Hub mockup.
// Returns the original value unchanged if it can't be parsed as a date.
export function formatShortDate(value: string | null | undefined): string {
  if (!value) return value ?? '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
}

